/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetStatsByDriversQueryParams, GetStatsByDrivers200, GetStatsByDrivers400, GetStatsByDriversQueryResponse } from '../entities/GetStatsByDrivers'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1StatsByDriversResponseSchema } from './v1/statsByDriversResponseSchema'
import { z } from 'zod'

export const getStatsByDriversQueryParamsSchema = z.object({
  drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
  from: z.string().describe('Начальная дата').optional(),
  limit: z.number().int().min(1).max(50).default(10).describe('Количество записей'),
  offset: z.number().int().min(0).default(0).describe('Сдвиг'),
  phone: z.string().describe('Номер водителя').optional(),
  to: z.string().describe('Конечная дата').optional(),
}) as unknown as ToZod<GetStatsByDriversQueryParams>

/**
 * @description OK
 */
export const getStatsByDrivers200Schema = z.lazy(() => v1StatsByDriversResponseSchema) as unknown as ToZod<GetStatsByDrivers200>

/**
 * @description Bad Request
 */
export const getStatsByDrivers400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDrivers400>

export const getStatsByDriversQueryResponseSchema = z.lazy(() => getStatsByDrivers200Schema) as unknown as ToZod<GetStatsByDriversQueryResponse>